import React from 'react';
import PropTypes from 'prop-types';

class DropdownItemComponent extends React.Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    const { handleChange, assoc } = this.props;
    e.preventDefault();
    handleChange(assoc.ID);
  }

  render() {
    const { assoc } = this.props;
    return (
      <li className={assoc.Selected ? 'selected' : ''}>
        <button type="button" onClick={this.handleClick}>
          {assoc.Name}
        </button>
      </li>
    );
  }
}

DropdownItemComponent.propTypes = {
  assoc: PropTypes.shape({
    ID: PropTypes.number.isRequired,
    Name: PropTypes.string.isRequired,
    Selected: PropTypes.bool.isRequired,
  }).isRequired,
  handleChange: PropTypes.func.isRequired,
};

DropdownItemComponent.displayName = 'DropdownItemComponent';

// Uncomment properties you need
// DropdownItemComponent.propTypes = {};
// DropdownItemComponent.defaultProps = {};

export default DropdownItemComponent;
